import * as React from 'react';
import { createFilterOptions } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export default function MultiSelectProductFormat({ data, onChange, name, resetFilter, selectAll, tmpData }) {
  const { options, label } = data;
  const filter = createFilterOptions();
   const [selectedOptions, setSelectedOptions] = React.useState(tmpData? [...tmpData] : []);
  React.useEffect(() => {    
    if(resetFilter)
    handleClearOptions && handleClearOptions();
  }, [resetFilter])

  const allSelected = options && selectedOptions ? options.length === selectedOptions.length : false;
  const handleToggleOption = selectedOptions =>
    setSelectedOptions(selectedOptions);
  const handleClearOptions = () => {
    setSelectedOptions([])
  };

  React.useEffect(()=>{
   if(tmpData && tmpData.length === 0){
    handleClearOptions();
   }
  }, [tmpData])

  const handleSelectAll = isSelected => {
    if (isSelected) {
      setSelectedOptions(options);
    } else {
      handleClearOptions();
    }
  };

  const handleToggleSelectAll = () => {
    handleSelectAll && handleSelectAll(!allSelected);
  };

  const handleChange = (event, selectedOptions, reason) => {
    if (reason === "selectOption" || reason === "removeOption") {
      if (selectedOptions.find(option => option.value === "select-all")) {
        handleToggleSelectAll();
        let result = [];
        result = options.filter(el => el.value !== "select-all");
        if(selectAll == 'N') {
        return onChange({[name]: []});
        } else {
          return onChange({ [name]: result }, 'All', event);          
        }
      } else {
        handleToggleOption && handleToggleOption(selectedOptions);
        return onChange({ [name]: selectedOptions }, 'Option');
      }
    } else if (reason === "clear") {
      handleClearOptions && handleClearOptions();
      return onChange({ [name]: [] }, 'Clear');
    }
  };

  const optionRenderer = (props, option, { selected }) => {
    const selectAllProps =
      option.value === "select-all" // To control the state of 'select-all' checkbox
        ? { checked: allSelected }
        : {};
    return (
      <li {...props}>
        <Checkbox
          color="primary"
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          style={{ marginRight: 8 }}
          checked={selected}
          {...selectAllProps}
        />
        {option.label}
      </li>
    );
  };

  return (
    <Autocomplete
      sx={{ my: 0.25, mr: 2 }}
      multiple
      id="checkboxes-tags-demo"
      options={options}
      size="small"
      value={selectedOptions}
      noOptionsText={'Empty'}
      onChange={handleChange}
      name={name}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      disableCloseOnSelect
      getOptionLabel={(option) => option.label}
      filterOptions={(options, params) => {
        const filtered = filter(options, params).slice(0, 500);
        if(selectAll == 'N') {
        return [...filtered];
        } else{
        return [{ label: "All", value: "select-all" }, ...filtered];
        }
      }}
      renderOption={optionRenderer}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={label} />
      )}
    />
  );
}
